import { Navigate, Outlet, useRouteLoaderData } from 'react-router';
import type { rootLoader } from '@/root';

export const AuthenticatedLayout = () => {
  const rootLoaderData = useRouteLoaderData<Awaited<ReturnType<typeof rootLoader>>>('root');
  if (!rootLoaderData?.session?.user || !rootLoaderData?.session?.isAuthenticated) {
    return <Navigate replace to="/auth/signin" />;
  }

  return <Outlet />;
};
